<template>
  <div id="about" class="container">
    <h1>Let us entertain you</h1>
    <div class="frame row">
      <div class="col-md-12 bottom-line">
        <p>
          <span>Seit 2012 perfektionieren die studierten Musiker mit viel Eifer und Leidenschaft</span>
          <span>ihr Konzept für ungezwungene und gleichzeitig künstlerisch anspruchsvolle</span>
          <span>Unterhaltung - handgemacht und authentisch.</span>
        </p>
        <p>
          <span>Ein stilistisch breit gefächertes Repertoire überzeugt ein ebenso breites Publikum.</span>
          <span>Spontaneität, Witz und Charme lassen eine lebendige und eindrucksvolle</span>
          <span>Atmosphäre entstehen, die unaufdringlich und gediegen bis ausgelassen und</span>
          <span>mitreißend sein kann.</span>
        </p>
      </div>
      <div class="col-md-6 col-sm-6 left">
        <ul class="numbers" style="margin-bottom: 1em;">
          <li>Folgende Besetzungen sind möglich:</li>
          <li>Duo = Gesang + Piano</li>
          <li>Trio = Gesang + Piano + Schlagzeug</li>
          <li>Wunschbesetzung = Trio + Sängerin + Gitarre + Bläser + Streicher + ?</li>
        </ul>
        <p>
          <span>Bemerkenswert ist der fulminante</span>
          <span>Klang der Trio-Variante, der dem einer</span>
          <span>größeren Band in nichts nachsteht.</span>
          <span>Die Vorteile der kompakten Besetzung:</span>
        </p>
        <ul style="margin-top: 1em;">
          <li>hohe Flexibilität und Dynamik</li>
          <li>ausgewogener und kraftvoller Sound</li>
          <li>geringer logistischer Aufwand</li>
          <li>moderate Preise trotz höchster Qualität</li>
        </ul>
      </div>
      <div class="col-md-6 col-sm-6 right">
        <p>
          <span>Wir bieten das All-Inclusive-Paket:</span>
        </p>
        <ul style="margin: 1em 0;">
          <li>professionelles Sound- und Lichtdesign entsprechend der Location</li>
          <li>individuelle Veranstaltungsplanung (Musikwünsche, zeitlicher Ablauf, ...)</li>
          <li>Charmante Moderationen/Animationen</li>
        </ul>
        <p>
          <span>Eine hohe Sensibilität für Stimmungen,</span>
          <span>unwiderstehliche Grooves und packendes</span>
          <span>Entertainment sorgen für unvergessliche</span>
          <span>Abende mit den GENTS OF JAZZ.</span>
        </p>
      </div>
    </div>
    <h2>Repertoire</h2>
    <div class="frame">
      <p style="padding-bottom: 4px">
        <span>Clueso / Coldplay / Frank Sinatra / Jamie Cullum / Max Mutzke / Michael Buble / </span>
        <span>Michael Jackson / Robbie Williams / Roger Cicero / Sting / Stevie Wonder / Toto / ...</span>
      </p>
    </div>
    <h2>Referenzen</h2>
    <div class="frame">
      <p style="padding-bottom: 4px">
        <span>Schlosshotel Burg Schlitz / Hotel Elephant Weimar / Industrieclub Thüringen / </span>
        <span>The Grand Ahrenshoop / Radisson Blue / Romantikhotel Meerane</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
    padding: 0;
    line-height: 18px;
  }

  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      line-height: 18px;
    }

    &.numbers li {
      padding-left: 17px;
      text-indent: -17px;
      &:nth-child(2):before {
        content: "1)";
        padding-right: 6px;
      }
      &:nth-child(3):before {
        content: "2)";
        padding-right: 5px;
      }
      &:nth-child(4):before {
        content: "3)";
        padding-right: 5px;
      }
    }

    &:not(.numbers) li {
      padding-left: 10px;
      text-indent: -10px;
      &:before {
        content: "-";
        padding-right: 5px;
      }
    }
  }

  @media all and (min-width: 540px) {
    p > span {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/About/About.vue